import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ApiClientService} from '../../../services/api-client.service';
import {ResidentForSelect} from '../../../types/data.types';
import {DirectoryService} from '../../../services/directory.service';
import { AuthenticationService } from '../../../services/authentication.service';
import {DatePipe} from '@angular/common';
import {AmenitiesService} from '../../../services/amenities.service';

declare const $: any;
declare const toastr: any;
declare const swal: any;
declare const moment: any;

@Component({
    selector: 'amenities-detailed-view',
    templateUrl: './amenities-detailed-view.component.html',
    styleUrls: ['./amenities-detailed-view.component.scss']
})

export class AmenitiesDetailedViewComponent implements OnInit, OnDestroy {
    @ViewChild('form') form;
    navPosition = 'info';
    comment = '';
    suites = [];
    residents = [];
    buildingSelectIsDisabled = false;
    maxDate = new Date();
    paymentMethods = {
        cash: 'Cash',
        cheque: 'Cheque',
        credit_card: 'Credit Card',
    };
    noteEditMode = false;
    newNote = '';
    usesCopy = '';

    constructor(public api: ApiClientService,
                public amenitiesService: AmenitiesService,
                public directoryService: DirectoryService,
                public authenticationService: AuthenticationService
    ) {}

    ngOnInit() {
        this.amenitiesService.onPaymentTableAction.subscribe(() => {
            this.navPosition = 'payment';
        });
    }

    onSubmit(data: any): void {
        const url = `/v1/booking/${this.amenitiesService.selectedItemData.id}.json`;
        this.amenitiesService.api.patch('domainAmenities', url, data).subscribe(
            () => this.updateView('The Field was successfully updated', false),
            (error) => this.api.errorHandler(error, 'Update failed!')
        );
    }

    updateView(msg: string, close = true): void {
        if (msg) toastr.success(msg);
        this.amenitiesService.toggleDetailedView(this.amenitiesService.selectedItemData, true);
        this.amenitiesService.getData();
        if (close) this.amenitiesService.toggleDetailedView(null, false);
    }

    setEditModeFor(item, fieldName: string, state: boolean, form?) {
        this.setEditModeForAll(false);
        if(fieldName != 'building' && fieldName != 'unit' && fieldName != 'resident') {
            item.formFields[fieldName].editMode = state;
            if(fieldName == 'incidentAt')
                setTimeout(() => this.initTimepicker(), 300);
        } else {
            if(state) {
                this.getSuites(this.amenitiesService.selectedItemData.buildingId, this.amenitiesService.selectedItemData.suiteId, form);
                if(this.amenitiesService.selectedItemData.suiteId === 0)
                    this.residents.push(new ResidentForSelect(0, 'Other'));
            }
            item.formFields['building'].editMode = state;
            item.formFields['unit'].editMode = state;
            item.formFields['resident'].editMode = state;
        }
    }

    setEditModeForAll(state: boolean) {
        for(const field in this.amenitiesService.selectedItemData.formFields)
            this.amenitiesService.selectedItemData.formFields[field].editMode = state;
    }

    applyChanges(item, form, changedValue, formField) {
        if (form.dirty) {
            item[formField] = form.value[formField];
            this.onSubmit(changedValue);
            if (form.valid) this.turnEditMode(false);
        } else {
            this.turnEditMode(false);
        }
    }

    changeBuilding(buildingId: string, form) {
        form.controls['unit'].reset();
        form.controls['resident'].reset();
        this.getSuites(+buildingId, null, form);
    }

    getSuites(buildingId: number, suiteId?: number, form?): void {
        if (!buildingId) return;
        const url = `/v1/suite/select.json?per-page=1000&order-by=suiteNumber|asc&building_id=${buildingId}`;
        this.buildingSelectIsDisabled = true;
        this.api.get('domainBD', url).subscribe(
            res => {
                this.suites = [];
                const suites = JSON.parse(res._body).entities || [];
                suites.forEach(suite => this.suites.push({id: suite.id, name: suite.suiteNumber}));
                this.suites.push({id: 0, name: 'Other'});
                if (suiteId) this.getResidents(suiteId, form);
                this.buildingSelectIsDisabled = false;
            },
            error => {
                this.buildingSelectIsDisabled = false;
                this.api.errorHandler(error, 'Failed get suites');
            }
        );
    }

    changeUnit(suiteId: string, form) {
        if(form.controls['resident'].value !== 0)
            form.controls['resident'].reset();
        this.getResidents(+suiteId, form);
        if (suiteId + '' === '0') {
            form.controls['resident'].setValue(0);
            setTimeout(() => {
                form.controls['otherSuite'].reset();
                form.controls['otherResident'].reset();
                this.residents.push(new ResidentForSelect(0, 'Other'));
            }, 0);
        }
    }

    suiteToSearchSelect(arr: Array<any>) {
        return arr.map(suite => ({value: suite.id, optionText: suite.name}));
    }

    getResidents(suiteId: number, form): void {
        if (!suiteId) return;
        const url = `/v1/residents/select.json?per-page=1000&suite_id=${suiteId}`;
        this.api.get('domainBD', url).subscribe(
            res => {
                this.residents = [];
                if(form.value.unit !== 0) {
                    const residents = JSON.parse(res._body).entities;
                    residents.forEach(item => {
                        this.residents.push(
                            new ResidentForSelect(item.id, item.fullName, [], item.email)
                        );
                    });
                }
                this.residents.push(new ResidentForSelect(0, 'Other'));
            },
            error => this.api.errorHandler(error, 'Failed get Residents')
        );
    }

    openTimepicker(): void {
        $('#timepicker').timepicker('showWidget');
    }

    getTime(dateString) {
        return (new DatePipe('en-US')).transform(dateString, 'hh:mm a');
    }

    getDateTimeFromForm(dateProperty, timeProperty): Date {
        const date = new Date(this.form.value[dateProperty]);
        const time = (<any>document.getElementsByName(timeProperty)[0]).value;
        const timeObj = new Date(`01/01/1970 ${time}`);
        const hours   = timeObj.getHours();
        const minutes = timeObj.getMinutes();
        date.setHours(hours);
        date.setMinutes(minutes);
        return moment(date).format('YYYY-MM-DD HH:mm');
    }

    initTimepicker() {
        $('#timepicker').timepicker().on('changeTime.timepicker', e => this.form.control.markAsDirty());
    }

    getPaymentString() {
        let method = '';
        this.amenitiesService.selectedItemData.payments.filter((payment) => {
            if(payment.paymentType)
                method = payment.paymentType;
        });
        if(method == 'credit_card') {
            const cardPayment = this.amenitiesService.selectedItemData.stripePayments.find(payment => payment.cardType && payment.cardNumber);
            return cardPayment ? `${cardPayment.cardType} *${cardPayment.cardNumber}` : '';
        } else
            return this.paymentMethods[method];
    }

    addNote(): void {
        if(this.newNote != '' &&  (this.newNote.replace(/&nbsp;/g, '')).replace(/\s/g, '') != '') {
            const url = `/v1/booking_notes.json`;
            const data = {booking: this.amenitiesService.selectedItemData.id, noteText: this.newNote};
            this.amenitiesService.api.post('domainAmenities', url, data).subscribe(
                res => {
                    toastr.success('Note was successfully created');
                    this.amenitiesService.selectedItemData.notes.unshift(res);
                    this.newNote = '';
                    this.amenitiesService.getData();
                    this.noteEditMode = false;
                },
                error => this.api.errorHandler(error, 'Note creation failed!')
            );
        } else
            toastr.warning('Note should not be blank');
    }

    turnNoteEditMode(value) {
        this.noteEditMode = value;
    }

    turnEditMode(on) {
        if(this.amenitiesService.selectedItemData.isCanEdit && this.amenitiesService.selectedItemData.status == 'pending') {
            if (on) {
                if (!this.amenitiesService.selectedItemData.formFields.uses.editMode)
                    this.usesCopy = this.amenitiesService.selectedItemData.uses;
                this.amenitiesService.selectedItemData.formFields.uses.editMode = true;
            } else {
                this.usesCopy = '';
                this.amenitiesService.selectedItemData.formFields.uses.editMode = false;
            }
        }
    }

    ngOnDestroy() {
        this.amenitiesService.onPaymentTableAction.observers = [];
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/amenities/amenities-detailed-view/amenities-detailed-view.component.ts